import React from 'react';
import PropTypes from 'prop-types';

import TopTabs from '../containers/TopTabs';
import RightNav from '../containers/RightNav';

const TopNavigation = ({ reportTopTabClicked }) => (
    <div className="hd-topNavigation">
      <TopTabs reportTopTabClicked={reportTopTabClicked} />
      <RightNav />
    </div>
);

TopNavigation.propTypes = {
  reportTopTabClicked: PropTypes.func,
};

export default TopNavigation;
